import { render, staticRenderFns } from "./StatsTab.vue?vue&type=template&id=317b2fcc&"
import script from "./StatsTab.vue?vue&type=script&lang=js&"
export * from "./StatsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports